import React, { useState } from 'react';

const CompoundInterestCalculator = ({ onTableGenerated }) => {
  const [principal, setPrincipal] = useState('');
  const [contribution, setContribution] = useState('');
  const [contributionFreq, setContributionFreq] = useState(30);
  const [compoundFreq, setCompoundFreq] = useState(1);
  const [annualRate, setAnnualRate] = useState('');
  const [years, setYears] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleCalculate = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    let p = Number(principal) || 0;
    let c = Number(contribution) || 0;
    const rate = Number(annualRate) / 100 || 0;
    const yrs = Number(years) || 0;
    const contribFreq = Number(contributionFreq);
    const compFreq = Number(compoundFreq);

    if (yrs <= 0) {
      setError('Please enter a valid number of years.');
      return;
    }

    let balance = p;
    let totalContrib = p;
    const totalDays = Math.floor(yrs * 365);
    const monthlyTable = [];

    for (let day = 1; day <= totalDays; day++) {
      if (day % contribFreq === 0) {
        balance += c;
        totalContrib += c;
      }
      if (compFreq > 0 && day % compFreq === 0) {
        const ratePerDay = rate * (compFreq / 365);
        balance += balance * ratePerDay;
      }
      if (day % 30 === 0) {
        const prevInterest = monthlyTable.reduce((a, b) => a + b.interest, 0);
        const monthInterest = balance - totalContrib - prevInterest;
        monthlyTable.push({ month: day / 30, interest: monthInterest, balance });
      }
    }

    setResult({
      totalContrib,
      totalInterest: balance - totalContrib,
      finalBalance: balance
    });

    if (onTableGenerated && typeof onTableGenerated === 'function') {
      onTableGenerated(monthlyTable);
    }
  };

  return (
    <div>
      <h3>💎 Compound (MMF/Sacco)</h3>
      <form onSubmit={handleCalculate}>
        <input
          type="number"
          placeholder="Initial Amount"
          value={principal}
          onChange={(e) => setPrincipal(e.target.value)}
          step="0.01"
          min="0"
        />
        <input
          type="number"
          placeholder="Contribution Amount"
          value={contribution}
          onChange={(e) => setContribution(e.target.value)}
          step="0.01"
          min="0"
        />
        <select
          value={contributionFreq}
          onChange={(e) => setContributionFreq(Number(e.target.value))}
        >
          <option value={1}>Daily Contribution</option>
          <option value={30}>Monthly Contribution</option>
          <option value={365}>Annual Contribution</option>
        </select>
        <select
          value={compoundFreq}
          onChange={(e) => setCompoundFreq(Number(e.target.value))}
        >
          <option value={0}>No Compounding</option>
          <option value={1}>Daily Compounding</option>
          <option value={30}>Monthly Compounding</option>
          <option value={365}>Annual Compounding</option>
        </select>
        <input
          type="number"
          placeholder="Annual Interest Rate %"
          value={annualRate}
          onChange={(e) => setAnnualRate(e.target.value)}
          step="0.01"
          min="0"
        />
        <input
          type="number"
          placeholder="Years"
          value={years}
          onChange={(e) => setYears(e.target.value)}
          step="0.1"
          min="0"
        />
        <button type="submit" className="btn-main">
          Generate Breakdown
        </button>
      </form>

      {error && (
        <div className="error" role="alert">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      )}

      {result && (
        <div className="results">
          <div className="results-header">
            <span className="results-icon">💎</span>
            <span className="results-title">Summary</span>
          </div>
          <div className="results-content">
            <div className="result-item">
              <span className="result-label">Total Contributions</span>
              <span className="result-value">{result.totalContrib.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Total Interest</span>
              <span className="result-value">{result.totalInterest.toFixed(2)}</span>
            </div>
            <div className="result-item highlight">
              <span className="result-label">Final Balance</span>
              <span className="result-value">{result.finalBalance.toFixed(2)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompoundInterestCalculator;
